import React from "react";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import SidebarSearchInput from "features/Admin/components/SidebarSearchInput";
import { Icon, Loader, Popup } from "semantic-ui-react";
import { Collapse } from "react-collapse";
import Radium from "radium";

class SidebarList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			currentSearch: "",
			labelFormat: this.props.defaultLabel,
			collapseOpened: null,
			groupField: this.props.groupField,
			addButton: this.props.withAddButton,
		};
	}

	componentDidMount() {
		if (this.props.groupField === null || this.props.groupField === undefined) {
			this.setState({ groupField: "group" });
		}
	}

	toggleCollapse = (name) => {
		this.setState((prevState) => ({ ...prevState, collapseOpened: prevState.collapseOpened === name ? null : name }));
	};

	formatList = (list) => {
		let groups = [];
		let finalData = [];
		let { groupField } = this.state;
		let { groupFieldTrueName, groupFieldFalseName } = this.props;

		if (list && groupField !== null && groupField !== false) {
			list.forEach((l) => {
				if (l[groupField] !== null && l[groupField] !== "") {
					// If the grouo field is a bool, use the provided groupFieldTrueName and groupFieldFalseName
					const name =
						typeof l[groupField] === "boolean" && l[groupField] ? groupFieldTrueName : l[groupField] === false ? groupFieldFalseName : l[groupField];
					if (!groups.includes(name)) {
						groups.push(name);

						finalData.push({
							name: name,
							elts: list.filter((i) => i[groupField] === l[groupField]),
						});
					}
				}
			});

			if (list.filter((i) => i[groupField] === "" || i[groupField] === null).length > 0) {
				finalData.push({
					name: "Aucun " + [groupField],
					elts: list.filter((i) => i[groupField] === "" || i[groupField] === null),
				});
			}

			return finalData;
		} else {
			return [
				{
					name: "Aucun groupe",
					elts: list,
				},
			];
		}
	};

	render() {
		const { list, entity } = this.props;
		const { labelFormat, collapseOpened } = this.state;
		const focusedEltId = this.props.focusedEltId ? this.props.focusedEltId.id : null;
		let that = this;

		return (
			<div style={styles.sidebarContainer} className="sidebarContainer">
				<div style={styles.sidebarEntete}>
					{this.props.addButtonText && this.props.onAddButtonClick && (
						<SecondaryBlueButton
							text={<Icon name="add" />}
							type="button"
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								this.props.onAddButtonClick();
							}}
							style={{ width: "100%", margin: "0 .25em 20px 0" }}
						>
							{this.props.addButtonText}
						</SecondaryBlueButton>
					)}
					<SidebarSearchInput onChange={(e) => this.setState({ currentSearch: e.target.value })} />

					<div style={styles.sidebarContentHeader}>
						<span style={{ float: "left" }}>{entity}</span>
						<span style={{ float: "right" }}>
							{list.loading && <Loader active inline size="tiny" />}
							{!list.loading && list.data && <span>{list.data.length}</span>}
						</span>
					</div>
				</div>

				<div style={styles.sidebarContentContainer} className="sidebarContentContainer">
					{this.state.currentSearch !== "" && list.data && (
						<div
							style={{
								color: "#e0e0e0",
								marginLeft: 10,
								marginBottom: 10,
								fontSize: "0.8em",
							}}
						>
							Résultats de la recherche :&nbsp;
							{list.data.filter((item) => labelFormat(item).toLowerCase().search(that.state.currentSearch.toLowerCase()) !== -1).length}
						</div>
					)}

					{list.data &&
						this.formatList(list.data)
							.sort((a, b) => a.name?.localeCompare(b.name))
							.filter(
								(group) => group.elts.filter((l) => labelFormat(l).toLowerCase().search(that.state.currentSearch.toLowerCase()) !== -1).length > 0
							)
							.map((group, i) => {
								return (
									<div key={i}>
										<div
											style={styles.sidebarGroup}
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												this.toggleCollapse(group.name);
											}}
										>
											{group.name}
											{collapseOpened === group.name ? (
												<Icon name="chevron down" style={styles.chevron} />
											) : (
												<Icon name="chevron left" style={styles.chevron} />
											)}
										</div>
										<Collapse key={"collapse" + i} isOpened={collapseOpened === group.name}>
											{group.elts
												.filter((l) => labelFormat(l).toLowerCase().search(that.state.currentSearch.toLowerCase()) !== -1)
												.map((l, i) => (
													<div
														key={l.id}
														style={sidebarContent(focusedEltId === l.id)}
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.props.onElementClick(l);
														}}
													>
														{focusedEltId === l.id ? <Icon name="chevron right" size="small" /> : ""}
														{labelFormat(l)}

														{entity === "UTILISATEURS" && l.rights === "ADMIN" && (
															<Popup
																content="Administrateur"
																size="mini"
																position="right center"
																trigger={
																	<Icon
																		name="star"
																		style={{
																			marginLeft: 5,
																			position: "relative",
																			top: -1,
																			float: "right",
																		}}
																	/>
																}
															/>
														)}
													</div>
												))}
										</Collapse>
									</div>
								);
							})}
				</div>
			</div>
		);
	}
}

export default Radium(SidebarList);

const styles = {
	sidebarContainer: {
		width: "20%",
		height: "100vh",
		// overflowY: 'hidden',
		display: "inline-block",
		background: "#1a2226",
		fontSize: "1rem",
		color: "#4d6770",
		padding: "10px 0 135px 0",
	},
	sidebarEntete: {
		padding: 10,
	},
	sidebarContentContainer: {
		width: "100%",
		height: "calc(100vh - 200px)",
		overflowY: "auto",
	},
	sidebarContentHeader: {
		color: "#4d6770",
		width: "100%",
		marginTop: 20,
	},
	sidebarContent: {
		width: "100%",
		backgroundColor: "#2c3b41",
		padding: "7px 10px",
		color: "#748b94",
		fontSize: "0.8rem",
		cursor: "pointer",
		":hover": {
			backgroundColor: "#36454b",
		},
		":active": {
			backgroundColor: "#36454b",
		},
	},
	sidebarGroup: {
		backgroundColor: "#1e282c",
		width: "100%",
		padding: "7px 10px",
		color: "#fff",
		fontSize: "0.9rem",
		cursor: "pointer",
		textTransform: "uppercase",
	},
	chevron: {
		float: "right",
	},
};

const sidebarContent = (active) => ({
	width: "100%",
	backgroundColor: active ? "#36454b" : "#2c3b41",
	padding: "7px 10px",
	color: active ? "#fff" : "#748b94",
	fontSize: "0.8rem",
	cursor: "pointer",
	":hover": {
		backgroundColor: "#36454b",
	},
	":active": {
		backgroundColor: "#36454b",
	},
});
